import api from '@/api';
import * as types from './mutation-types';

export default {
    // 공지/이벤트 목록 조회
    async fetchNoticeList({ commit }, { category = 'all', query = null } = {}) {
        const res = await api.get('/Notices', {
            params: { category, query },
        });

        // Admin API 공통 응답: { resultCode, message, data: [...] }
        commit(types.FETCH_NOTICE_LIST, res.data.data);
    },

    // 단건 조회 (직접 접근 or 새로고침 대비)
    async fetchNoticeById({ commit, state }, id) {
        const numericId = Number(id);

        // 이미 목록에 있으면 그걸 사용
        const existing = state.noticeItems.find(
            (n) => n.id === numericId
        );

        if (existing) {
            commit(types.SET_CURRENT_NOTICE, existing);
            return existing;
        }

        // 없으면 API로 조회
        const res = await api.get(`/Notices/${numericId}`);
        const notice = res.data.data;

        commit(types.SET_CURRENT_NOTICE, notice);
        return notice;
    },
};
